import { render, staticRenderFns } from "./sosDialog.vue?vue&type=template&id=4fd40669&scoped=true&"
import script from "./sosDialog.vue?vue&type=script&lang=js&"
export * from "./sosDialog.vue?vue&type=script&lang=js&"
import style0 from "./sosDialog.vue?vue&type=style&index=0&id=4fd40669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd40669",
  null
  
)

export default component.exports